import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import moment from 'moment';
import PageRecipientOrders from '@/views/v3/inbox_manager/PageRecipientOrders.vue';
import Inbox from '@/components/v3/inbox_manager/Inbox.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import PageRecipientDetails from '@/plugins/graphql/queries/v2/copilot_inbox_manager/page-recipient-details.gql';
// import PageRecipientOrders from '@/plugins/graphql/queries/v2/copilot_inbox_manager/page-recipient-orders.gql';
import { PageRecipientDetailsModel } from '@/helpers/entities/models/PageRecipientDetailsModel';
import copilotUserDetails from '@/plugins/graphql/subscriptions/copilot_inbox_manager/page-recipient-details.gql';
import UpdateLanguage from '@/plugins/graphql/mutations/copilot_inbox_manager/update-language-pref.gql';
import UpdateTimezone from '@/plugins/graphql/mutations/copilot_inbox_manager/update-timezone.gql';
// import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import { textTruncate } from '@/helpers/text_truncate';
import BaseInnerLoader from '@/components/v2/BaseInnerLoader';
import { ORANGE } from '@/helpers/constants/Switch';
import ChatbotGlobalSettings from '@/plugins/graphql/queries/v2/chatbot_ai_settings/chatbot-global-settings.gql';
import SaveRecipientChatbotSettings from '@/plugins/graphql/mutations/chatbot_ai_settings/save-chatbot-recipient-settings.gql';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import chatbotRecipientSettingSubscription from '@/plugins/graphql/subscriptions/copilot_inbox_manager/chatbot-recipient-settings.gql';
import chatbotGlobalSettingSubscriptionApp from '@/plugins/graphql/subscriptions/copilot_inbox_manager/chatbot-global-settings-app.gql';
let AccountDetails = class AccountDetails extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, PaginatorMixin, AlertMixin
// CleverTapEventsMixin
) {
    constructor() {
        super(...arguments);
        this.accountDummyDetails = {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            name: 'Ali connors',
            mobileNumber: '+639123456789',
            facebook: 'facebook.com/ali',
            instagram: 'instagram.com/ali',
            gender: 'Male',
            address: 'Sample Address',
            languagePref: 'Filipino',
            timezone: 'UTC+08:00',
            lastInteraction: 'June 10, 2024',
            messengerMarketingSub: 'Yes',
        };
        this.pageRecipientDetails = {};
        this.pageRecipientOrders = null;
        this.selectedUuid = '';
        this.facebookIcon = require('@/assets/icons/facebook.svg');
        this.instaIcon = require('@/assets/images/instagram-logo.svg');
        this.selectedLanguage = 'N/A';
        this.selectedTimezone = 'N/A';
        this.languageSelections = ['N/A'];
        this.timezoneSelections = ['N/A'];
        this.autopilotOn = true;
        this.disabledToggle = false;
        this.sleepUntil = null;
        this.chatbotGlobalSetting = null;
        this.enabledRecipientChatbot = true;
        this.saving = false;
        this.sleepCheckInterval = null;
        this.displaySleepMessage = false;
    }
    get avatarSize() {
        if (this.xsOnly) {
            return '30';
        }
        return '60';
    }
    get switchColor() {
        return ORANGE;
    }
    get optDateDisplay() {
        if (this.pageRecipientDetails.activeSubscription) {
            // return this.humanReadableDate(
            //   this.pageRecipientDetails.messengerMarketingSubscription.optInDate
            // );
            return 'Opt-in Date';
        }
        return 'Opt-out Date';
    }
    get optDateValue() {
        if (this.pageRecipientDetails.activeSubscription) {
            return this.humanReadableDate(this.pageRecipientDetails.optInDate);
        }
        return this.humanReadableDate(this.pageRecipientDetails.optOutDate);
    }
    humanReadableDate(date) {
        return moment(date).format('MMMM DD, YYYY');
    }
    humanReadableTime(date) {
        return moment(date).format('h:mm A');
    }
    toggleChatbot() {
        this.stopSleepCheckTimer();
        this.showConfirmationDialog();
    }
    toggleCancel() {
        this.autopilotOn = !this.autopilotOn;
    }
    toggleConfirm() {
        this.saving = true;
        const variables = {
            input: {
                pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                activate: this.autopilotOn,
            },
        };
        return this.$apollo
            .mutate({
            mutation: SaveRecipientChatbotSettings,
            variables,
        })
            .then(() => {
            const notif = this.successNotifSelect;
            this.successNotification(notif);
            this.saving = false;
        })
            .catch((e) => {
            this.saving = false;
            this.toggleCancel();
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.hideConfirmationDialog();
            this.$apollo.queries.pageRecipientDetails.refetch();
        });
    }
    get successNotifSelect() {
        if (this.autopilotOn) {
            return `Successfully Turned on Chatbot for ${this.pageRecipientDetails.name}`;
        }
        return `Successfully Turned off Chatbot for ${this.pageRecipientDetails.name}`;
    }
    get sleepToggleHeader() {
        if (this.autopilotOn) {
            return 'Enable Chatbot AI';
        }
        return 'Disable Chatbot AI';
    }
    get sleepToggleMessage() {
        if (this.autopilotOn) {
            return `This action will turn on the chatbot AI for user ${this.pageRecipientDetails.name}. Do you want to proceed?`;
        }
        return `This action will turn off the chatbot AI for user ${this.pageRecipientDetails.name}. Do you want to proceed?`;
    }
    get sleepToggleConfirmLabel() {
        if (this.autopilotOn) {
            return 'Enable';
        }
        return 'Disable';
    }
    get chatbotIsAsleep() {
        return this.sleepUntil >= new Date();
    }
    get asleepText() {
        const date = this.humanReadableDate(this.sleepUntil);
        const time = this.humanReadableTime(this.sleepUntil);
        return `The Chatbot AI for this user is currently asleep and will not send automated messages. It will be available again on ${date} at ${time}.`;
    }
    get disabledText() {
        return 'The Chatbot AI for this user is currently disabled and will not send automated messages. To re-enable it, simply turn on the toggle below.';
    }
    truncatedText(text) {
        return textTruncate(text || '', 16);
    }
    async onLanguageChange(language) {
        return this.$apollo
            .mutate({
            mutation: UpdateLanguage,
            variables: {
                input: {
                    pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                    language,
                },
            },
        })
            .then((result) => {
            const data = result.data.copilotUpdateLanguagePref;
            if (data) {
                this.successNotification(`Successfully changed ${this.pageRecipientDetails.name}'s preferred language to ${language}`);
            }
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
    async onTimezoneChange(timezone) {
        return this.$apollo
            .mutate({
            mutation: UpdateTimezone,
            variables: {
                input: {
                    pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                    timezone,
                },
            },
        })
            .then((result) => {
            const data = result.data.copilotUpdateTimezone;
            if (data) {
                this.successNotification(`Successfully changed ${this.pageRecipientDetails.name}'s timezone to ${timezone}`);
            }
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
    sleepChecker() {
        if (!(this.sleepUntil >= new Date())) {
            this.stopSleepCheckTimer();
            this.displaySleepMessage = false;
        }
        else {
            this.displaySleepMessage = true;
        }
    }
    startSleepCheckTimer() {
        this.stopSleepCheckTimer();
        this.sleepChecker();
        if (this.sleepCheckInterval) {
            clearInterval(this.sleepCheckInterval);
        }
        this.sleepCheckInterval = setInterval(() => {
            this.sleepChecker();
        }, 1000); // Check every minute --- 1000 if every sec --- 60000 every minute
    }
    // Method to clear the timer
    stopSleepCheckTimer() {
        if (this.sleepCheckInterval) {
            clearInterval(this.sleepCheckInterval);
            this.sleepCheckInterval = null;
        }
    }
    // Clean up the timer when the component is destroyed
    beforeDestroy() {
        this.stopSleepCheckTimer();
    }
    queryGlobalChatbotSettings() {
        this.$apollo
            .query({
            query: ChatbotGlobalSettings,
            variables: {
                appUuid: this.$route.params.appUUID,
            },
            fetchPolicy: 'network-only',
        })
            .then(({ data }) => {
            const settings = data.chatbotGlobalSettings;
            const selectedOperation = settings.operationMode;
            const sleepUntilSetting = settings.sleepUntil;
            if (selectedOperation === 'off') {
                this.disabledToggle = true;
            }
            if (this.enabledRecipientChatbot) {
                if (settings.sleepOption === 'all_users') {
                    this.sleepUntil = sleepUntilSetting ? new Date(sleepUntilSetting) : null;
                }
                this.startSleepCheckTimer();
            }
            return data.chatbotGlobalSettings;
        });
    }
};
__decorate([
    Mutation('showConfirmationDialog')
], AccountDetails.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], AccountDetails.prototype, "hideConfirmationDialog", void 0);
AccountDetails = __decorate([
    Component({
        apollo: {
            pageRecipientDetails: {
                query: PageRecipientDetails,
                variables() {
                    return {
                        pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                    };
                },
                fetchPolicy: 'network-only',
                update(data) {
                    const recipientDetails = data.pageRecipient;
                    this.selectedUuid = recipientDetails.uuid;
                    this.selectedTimezone = recipientDetails.timezone || 'N/A';
                    this.selectedLanguage = recipientDetails.languagePref || 'N/A';
                    this.languageSelections = recipientDetails.listOfLanguages;
                    this.timezoneSelections = recipientDetails.listOfTimezones;
                    const recipientSetting = recipientDetails.chatbotRecipientSetting;
                    const sleepUntilSetting = new Date(recipientSetting.sleepUntil);
                    this.sleepUntil = sleepUntilSetting ? new Date(sleepUntilSetting) : null;
                    this.enabledRecipientChatbot = recipientSetting.enabled;
                    if (this.enabledRecipientChatbot) {
                        this.autopilotOn = true;
                    }
                    else {
                        this.autopilotOn = false;
                    }
                    if (this.enabledRecipientChatbot) {
                        if (recipientSetting.globalSleepOption === 'manually_messaged_users') {
                            this.sleepUntil = sleepUntilSetting ? new Date(sleepUntilSetting) : null;
                        }
                        this.startSleepCheckTimer();
                    }
                    this.queryGlobalChatbotSettings();
                    return new PageRecipientDetailsModel(recipientDetails);
                },
                skip() {
                    return !this.$store.state.selectedRecipient.uuid;
                },
                // fetchPolicy: 'cache-and-network',
                subscribeToMore: {
                    document: copilotUserDetails,
                    variables() {
                        return {
                            prGlobalId: this.$store.state.selectedRecipient.baseUuid,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        this.pageRecipientDetails = subscriptionData.data.copilotUserDetails.pageRecipient;
                        return subscriptionData.data.copilotUserDetails.pageRecipient;
                    },
                },
            },
            chatbotGlobalSetting: {
                query: ChatbotGlobalSettings,
                variables() {
                    return {
                        appUuid: this.$route.params.appUUID,
                    };
                },
                fetchPolicy: 'network-only',
                update(data) {
                    const settings = data.chatbotGlobalSettings;
                    const selectedOperation = settings.operationMode;
                    const sleepUntilSetting = settings.sleepUntil;
                    if (selectedOperation === 'off') {
                        this.disabledToggle = true;
                    }
                    if (this.enabledRecipientChatbot) {
                        if (settings.sleepOption === 'all_users') {
                            this.sleepUntil = sleepUntilSetting ? new Date(sleepUntilSetting) : null;
                        }
                        this.startSleepCheckTimer();
                    }
                    return data.chatbotGlobalSettings;
                },
                skip() {
                    return !this.$route.params.appUUID;
                },
                subscribeToMore: {
                    document: chatbotGlobalSettingSubscriptionApp,
                    variables() {
                        return {
                            appGlobalId: this.$store.state.appGlobalId,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        const global_settings = subscriptionData.data.chatbotGlobalSettingsApp.chatbotGlobalSettings;
                        if (this.enabledRecipientChatbot) {
                            if (global_settings.sleepOption === 'all_users') {
                                this.sleepUntil = global_settings.sleepUntil
                                    ? new Date(global_settings.sleepUntil)
                                    : null;
                            }
                            this.startSleepCheckTimer();
                        }
                        return global_settings;
                    },
                },
            },
            recipientSubscription: {
                query: ChatbotGlobalSettings,
                variables() {
                    return {
                        appUuid: this.$route.params.appUUID,
                    };
                },
                fetchPolicy: 'network-only',
                update(data) {
                    return data.chatbotGlobalSettings;
                },
                subscribeToMore: {
                    document: chatbotRecipientSettingSubscription,
                    variables() {
                        return {
                            prGlobalId: this.$store.state.selectedRecipient.baseUuid,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        const recipient_settings = subscriptionData.data.chatbotRecipientSettings.chatbotRecipientSettings;
                        const sleepUntilSetting = recipient_settings.sleepUntil;
                        if (this.enabledRecipientChatbot) {
                            if (recipient_settings.globalSleepOption === 'manually_messaged_users') {
                                this.sleepUntil = sleepUntilSetting ? new Date(sleepUntilSetting) : null;
                            }
                            this.startSleepCheckTimer();
                        }
                        return recipient_settings;
                    },
                },
            },
        },
        components: {
            PageTitle,
            Inbox,
            PageRecipientOrders,
            BaseInnerLoader,
            ConfirmationDialog,
        },
    })
], AccountDetails);
export default AccountDetails;
